import type { CreateSpace, Space } from '../space/space.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class SpaceFactory extends ObjectFactory<Space> {
  protected getDefaults(): Space {
    return {
      ...baseDocumentFactory.build(),
      code: 'IDF-01',
      description: 'Île-de-France regional space',
      name: 'Île-de-France',
    };
  }

  /** Build a CreateSpace body (no base document fields). Code is user-provided. */
  buildCreate(overrides: Partial<CreateSpace> = {}): CreateSpace {
    return {
      code: 'IDF-01',
      description: 'Île-de-France regional space',
      name: 'Île-de-France',
      ...overrides,
    };
  }
}

export type { Space };
export const spaceFactory = new SpaceFactory();
